import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchUserItems } from '../api/items';
import { currentUserAtom } from '../auth/AuthAtoms';

// Async atom — fetches items when the user is authenticated
const userItemsFetchAtom = atom(async (get) => {
    const user = get(currentUserAtom);
    if (!user) return { amounts: {}, caps: {} };
    const items = await fetchUserItems();
    const amounts = {};
    const caps = {};
    items.forEach(item => {
        amounts[item.itemType] = item.amount;
        if (item.cap != null) caps[item.itemType] = item.cap;
    });
    return { amounts, caps };
});

// Synchronous access to the async fetch state
const userItemsLoadableAtom = loadable(userItemsFetchAtom);

// Writable layer for optimistic updates (drinks used, rewards earned, etc.)
const userItemsOverrideAtom = atom(null);

// Public atom — self-loads on first read, writable for optimistic updates
// Shape: { energy_drink: 3, ... } — keyed by itemType → amount
export const userItemsAtom = atom(
    (get) => {
        const override = get(userItemsOverrideAtom);
        if (override !== null) return override;
        const fetched = get(userItemsLoadableAtom);
        return fetched.state === 'hasData' ? fetched.data.amounts : {};
    },
    (get, set, update) => {
        const override = get(userItemsOverrideAtom);
        let current;
        if (override !== null) {
            current = override;
        } else {
            const fetched = get(userItemsLoadableAtom);
            current = fetched.state === 'hasData' ? fetched.data.amounts : {};
        }
        set(userItemsOverrideAtom, typeof update === 'function' ? update(current) : update);
    }
);

export const userItemCapsAtom = atom((get) => {
    const fetched = get(userItemsLoadableAtom);
    return fetched.state === 'hasData' ? fetched.data.caps : {};
});
